import * as React from "react"
import type { SVGProps } from "react"
const SvgPlayCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m10.65 16.18 4.88-3.13a.7.7 0 0 0 .35-.62.7.7 0 0 0-.36-.63l-4.87-3.12a.7.7 0 0 0-.76-.04.7.7 0 0 0-.39.66v6.25q0 .45.39.67.39.21.76-.04M12 22.43a10 10 0 0 1-3.9-.79 10 10 0 0 1-3.17-2.14 10 10 0 0 1-2.14-3.17 10 10 0 0 1-.79-3.9q0-2.07.79-3.9a10 10 0 0 1 2.13-3.18Q6.28 4.01 8.1 3.22a10 10 0 0 1 3.9-.8q2.07 0 3.9.8a10 10 0 0 1 3.18 2.13q1.34 1.35 2.13 3.18a10 10 0 0 1 .79 3.9 10 10 0 0 1-.79 3.9 10 10 0 0 1-2.14 3.17q-1.34 1.36-3.17 2.14a10 10 0 0 1-3.9.79m0-2q3.35 0 5.68-2.33A7.7 7.7 0 0 0 20 12.43q0-3.35-2.33-5.68A7.7 7.7 0 0 0 12 4.43q-3.34 0-5.67 2.32A7.7 7.7 0 0 0 4 12.43q0 3.35 2.33 5.67A7.7 7.7 0 0 0 12 20.43" />
  </svg>
)
export default SvgPlayCircle
